import { useParams } from 'react-router-dom';
// import DefaultLayout from '../components/DefaultLayout';
import { Col, Row, Form, Input, Upload, Button, Spin, Checkbox } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editCar, getAllCars } from '../redux/actions/carsActions';
import Spinner from '../components/Spinner';
import '../edit-car.css';

function EditCar() {
    const { cars } = useSelector((state) => state.cars);
    const { loading } = useSelector((state) => state.alerts);

    const dispatch = useDispatch();

    const [car, setcar] = useState();
    const [totalcars, settotalcars] = useState([]);
    const { id } = useParams();

    const [name, setName] = useState('');
    const [capacity, setCapacity] = useState('');
    const [fuelType, setFuelType] = useState('');
    const [rentPerHour, setRentPerHour] = useState('');
    const [images, setImages] = useState([]);
    const [oldImages, setOldImages] = useState([]);
    const [imagesPreview, setImagesPreview] = useState([]);
    const [deleteImage, setDeleteImage] = useState(false);


    useEffect(() => {
        if (cars.length == 0) {
            dispatch(getAllCars());
        } else {
            settotalcars(cars);
            setcar(cars.find((o) => o._id === id));
            setName(car?.name);
            setCapacity(car?.capacity);
            setFuelType(car?.fuelType);
            setRentPerHour(car?.rentPerHour);
            setOldImages(car?.images);
        }
    }, [cars]);

    useEffect(() => {
        if (deleteImage) {
            // setOldImages((oldImages) => oldImages.slice(1));
            console.log(oldImages);
            // const newImages = oldImages.filter(element => element.id !== oldImages.id);
            // setOldImages({ oldImages: newImages });
        }
    }, [deleteImage, oldImages]);

    function onFinish() {

        const formData = new FormData();

        formData.append('name', name);
        formData.append('capacity', capacity);
        formData.append('fuelType', fuelType);
        formData.append('rentPerHour', rentPerHour);

        Array.from(images).forEach((image) => {
            formData.append('image', image);
        });

        dispatch(editCar(id, formData));
    }

    const updateCarImagesChange = (e) => {
        const file = e.target.files[0];
        previewFile(file);
        setImages(e.target.files);
    };

    const previewFile = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            if (reader.readyState === 2) {
                setImagesPreview((old) => [...old, reader.result]);
                // setImages((old) => [...old, reader.result]);
            }
        };

        // reader.onloadend = () => {
        //     setImagesPreview((old) => [...old, reader.result]);
        //     // setImages((old) => [...old, reader.result]);
        // };
    };

    // const updateCarImagesChange = (e) => {
    //     const files = Array.from(e.target.files[0]);

    //     setImages([]);
    //     setImagesPreview([]);
    //     setOldImages([]);

    //     files.forEach((file) => {
    //         const reader = new FileReader();

    //         reader.onload = () => {
    //             if (reader.readyState === 2) {
    //                 setImagesPreview((old) => [...old, reader.result]);
    //                 setImages((old) => [...old, reader.result]);
    //             }
    //         };

    //         reader.readAsDataURL(file);
    //     });
    // };

    const normFile = (e) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
        console.log(file);
    };

    return (
        <div>

            {loading == true && <Spinner />}

            <Row justify="center mt-5" gutter={24}>
                <Col lg={24} sm={24} xs={24} className="p-2">
                    {totalcars.length > 0 && (
                        <Form
                            initialValues={car}
                            className="bs1 p-2"
                            layout="vertical"
                            onFinish={onFinish}
                        >
                            <h3>Edit Car</h3>

                            <hr />
                            <Form.Item 
                                name="name" 
                                label="Car name"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item 
                                name="rentPerHour" 
                                label="Rent per hour"
                                value={rentPerHour}
                                onChange={(e) => {
                                    setRentPerHour(e.target.value);
                                }}>
                                <Input />
                            </Form.Item>

                            <Form.Item 
                                name="capacity" 
                                label="Capacity"
                                value={capacity}
                                onChange={(e) => {
                                    setCapacity(e.target.value);
                                }}>
                                <Input />
                            </Form.Item>

                            <Form.Item 
                                name="fuelType" 
                                label="Fuel Type"
                                value={fuelType}
                                onChange={(e) => {
                                    setFuelType(e.target.value);
                                }}>
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="image"
                                label="Car Image(s)"
                                type="image"
                                placeholder="browse files"
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                onChange={updateCarImagesChange}
                                value={images}
                            >
                                <Upload
                                    name="image"
                                    customRequest={dummyRequest}
                                    method="PUT"
                                    listType="picture"
                                    multiple={true}
                                    iconRender={() => {
                                        return <Spin></Spin>;
                                    }}
                                >
                                    <Button icon={<UploadOutlined />}>Click to Add Images</Button>
                                </Upload>
                            </Form.Item>

                            <Form.Item
                                name='deleteImages[]'
                                label='Delete Old Images?'
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setDeleteImage(true);
                                    } else {
                                        setDeleteImage(false);
                                    }
                                } }
                                value={oldImages}
                            >
                                <Row className="CarFormImage p-2" style={{display: 'flex', width: '100%'}}>
                                    {oldImages &&
                                    oldImages?.map((image) => (
                                        <><img key={image._id} src={image?.url} alt="Old Image Preview"
                                            style={{ height: '6rem', margin: '1rem' }} />
                                        <div>
                                            <Checkbox
                                                id={image._id}
                                                name='deleteImages[]'
                                                valuePropName={image.filename}
                                            > Delete?
                                            </Checkbox>
                                        </div></>
                                    ))}

                                </Row>
                            </Form.Item>

                            <div className="CarFormImage p-2">
                                {imagesPreview.map((image) => (
                                    <img key={image._id} src={image?.url} alt="Image Preview" 
                                        style={{ height: '80px', margin: '10px' }} />
                                ))}
                            </div>

                            <div className="text-right">
                                <button className="btn1">Edit CAR</button>
                            </div>
                        </Form>
                    )}
                </Col>
            </Row>
        </div>
    );
}

export default EditCar;
